import { useMutation } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router";
import { SENHA_MINIMA } from "@caixaflow/shared";
import { api, ErroApi } from "../api/cliente";
import { useDefinirSessao, useSessao } from "../api/sessao";
import type { Sessao } from "../api/tipos";
import { Campo } from "../components/Campos";
import { BotaoTema } from "../components/BotaoTema";
import { CreditosLogin } from "../components/Creditos";
import { Carregando, mensagemDeErro } from "../components/Estados";

export function PaginaTrocarSenha() {
  const { data: sessao, isPending } = useSessao();
  const navegar = useNavigate();
  const definirSessao = useDefinirSessao();
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erroLocal, setErroLocal] = useState<string | null>(null);

  const trocar = useMutation({
    mutationFn: () => api<Sessao>("/auth/trocar-senha", "POST", { senhaAtual, novaSenha }),
    onSuccess: (nova) => {
      definirSessao(nova);
      navegar("/", { replace: true });
    },
  });

  if (isPending) return <Carregando />;
  if (!sessao) return <Navigate to="/login" replace />;

  const enviar = (e: FormEvent) => {
    e.preventDefault();
    if (novaSenha !== confirmacao) {
      setErroLocal("A confirmação não confere com a nova senha.");
      return;
    }
    setErroLocal(null);
    trocar.mutate();
  };
  const erro = trocar.error instanceof ErroApi ? trocar.error : null;
  const obrigatoria = sessao.usuario.deveTrocarSenha;

  return (
    <div className="tela-login">
      <form className="card" onSubmit={enviar}>
        <div className="marca">
          <small>{sessao.usuario.nome}</small>
          <h1>{obrigatoria ? "Defina sua senha" : "Trocar senha"}</h1>
        </div>
        {obrigatoria && (
          <p className="mudo" style={{ margin: 0 }}>
            Por segurança, troque a senha provisória antes de continuar.
          </p>
        )}
        {(erroLocal || (trocar.error && !erro?.campos.length)) && (
          <div className="aviso erro" role="alert">
            {erroLocal ?? mensagemDeErro(trocar.error)}
          </div>
        )}
        <Campo rotulo="Senha atual" erro={erro?.doCampo("senhaAtual")}>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={senhaAtual}
            onChange={(e) => setSenhaAtual(e.target.value)}
          />
        </Campo>
        <Campo rotulo="Nova senha" dica={`mínimo ${SENHA_MINIMA} caracteres`} erro={erro?.doCampo("novaSenha")}>
          <input
            type="password"
            autoComplete="new-password"
            required
            minLength={SENHA_MINIMA}
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
          />
        </Campo>
        <Campo rotulo="Confirme a nova senha">
          <input
            type="password"
            autoComplete="new-password"
            required
            value={confirmacao}
            onChange={(e) => setConfirmacao(e.target.value)}
          />
        </Campo>
        <button className="btn primario largo" type="submit" disabled={trocar.isPending}>
          {trocar.isPending ? "Salvando…" : "Salvar nova senha"}
        </button>
      </form>
      <CreditosLogin />
      <BotaoTema className="flutuante" />
    </div>
  );
}
